import React, { FC, useEffect } from 'react';
import MainImageDisplayContainer from '../customiseDisplay/mainImageDisplayContainer/MainImageDisplayContainer';
import CustomiseErrorBoundary from './CustomiseErrorBoundary';
import BaseConfiguratorLayout from '../../../../common/components/layouts/baseConfiguratorLayout/BaseConfiguratorLayout';
import CustomiseControls from '../customiseControls/CustomiseControls';
import CustomiseMobileActions from './CustomiseMobileActions';
import StickyFooterContainer from '../footer/StickyFooterContainer';
import DisclaimerContainer from '../disclaimer/DisclaimerContainer';
import NavigationBarContainer from '../navigation/NavigationBarContainer';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import reactiveVarsService from '../../../../gqlCommon/service/reactiveVarsService';
import StockLiteListContainer from '../../StockLite/StockLiteListContainer';
import checkIfStockPageService from '../../../../gqlCommon/service/checkIfStockPage';
import { useHistory } from 'react-router';
import useTriggerFcOpen from '../../../../common/hooks/useTriggerFcOpen';

const CustomiseLayout: FC = () => {
  const { breakpoints } = useTheme<ISpcTheme>();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const history = useHistory();
  useTriggerFcOpen();

  useEffect(() => {
    return () => {
      if (!checkIfStockPageService.isInStockDetailsPage(history)) {
        reactiveVarsService.resetSelectedFeaturesIds();
      }
    };
  }, [history]);

  return (
    <CustomiseErrorBoundary>
      <BaseConfiguratorLayout
        navigationSlot={<NavigationBarContainer isCustomisePage={true} />}
        leftSlot={
          <>
            <MainImageDisplayContainer />
            {!isMobile && <StockLiteListContainer />}
          </>
        }
        footerSlot={<StickyFooterContainer />}
        disclaimerSlot={<DisclaimerContainer />}
        rightSlot={
          <>
            <CustomiseControls />
            <CustomiseMobileActions />
            {isMobile && <StockLiteListContainer />}
          </>
        }
      />
    </CustomiseErrorBoundary>
  );
};

export default CustomiseLayout;
